// extracted by mini-css-extract-plugin
export default {"confirmSection":"ContactConfirmation_confirmSection__cQRe+","confirmIcon":"ContactConfirmation_confirmIcon__IW-cc"};